import React from 'react';
import { TextField, Typography, Box, Grid, InputAdornment } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import LanguageIcon from '@mui/icons-material/Language';

export function ContactSection({ formData, onChange, errors }) {
  return (
    <Box sx={{ my: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <PhoneIcon sx={{ color: 'primary.main' }} />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Contact Information
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Contact Person Name *"
            id="contactPerson"
            value={formData.contactPerson || ''}
            onChange={(e) => onChange('contactPerson', e.target.value)}
            error={Boolean(errors?.contactPerson)}
            helperText={errors?.contactPerson}
            placeholder="Enter contact person name"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Email *"
            id="contactEmail"
            type="email"
            value={formData.contactEmail || ''}
            onChange={(e) => onChange('contactEmail', e.target.value)}
            error={Boolean(errors?.contactEmail)}
            helperText={errors?.contactEmail}
            placeholder="contact@property.com"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

       <Grid item xs={12} md={6}>
  <TextField
    fullWidth
    label="Primary Phone *"
    id="contactPhone"
    type="tel"
    value={formData.contactPhone || ''}
    onChange={(e) => onChange('contactPhone', e.target.value)}
    error={Boolean(errors?.contactPhone)}
    helperText={
      errors?.contactPhone || 
      (() => {
        const cleanPhone = (formData.contactPhone || '').replace(/[\s\-\(\)\+]/g, '');
        return cleanPhone.length === 10 ? '✅ Valid (10 digits)' : `Digits: ${cleanPhone.length}/10`;
      })()
    }
    placeholder="9876543210 or +91 98765 43210"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <PhoneIcon fontSize="small" />
        </InputAdornment>
      ),
    }}
  />
</Grid>


       <Grid item xs={12} md={6}>
  <TextField
    fullWidth
    label="Alternate Phone"
    id="alternatePhone"
    type="tel"
    value={formData.alternatePhone || ''}
    onChange={(e) => onChange('alternatePhone', e.target.value)}
    error={Boolean(errors?.alternatePhone)}
    helperText={errors?.alternatePhone ||
      (() => {
        const cleanPhone = (formData.alternatePhone || '').replace(/[\s\-\(\)\+]/g, '');
        if (!formData.alternatePhone) return 'Optional';
        return cleanPhone.length === 10 ? '✅ Valid (10 digits)' : `Digits: ${cleanPhone.length}/10`;
      })()
    }
    placeholder="+91 98765 43210"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <PhoneIcon fontSize="small" />
        </InputAdornment>
      ),
    }}
  />
</Grid>


        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Website (Optional)"
            id="website"
            type="url"
            value={formData.website || ''}
            onChange={(e) => onChange('website', e.target.value)}
            placeholder="https://yourproperty.com"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LanguageIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
